import React, { useEffect, useState } from 'react';
import { getUserId } from '../../store/auth/selectors';
import SidebarSecond from '../../components/Sidebar/SidebarSecond';
import { useDispatch, connect } from 'react-redux';
import './MissionsPage.scss';
import { MissionsProps } from './types';
import Sidebar from '../../components/Sidebar/Sidebar';
import {
    missionsDialogParams,
    editMissionsDialogParams,
    stagesDialogParams,
    editStagesDialogParams,
    exercisesDialogParams,
    editExercisesDialogParams,
} from './consts';
import FormDialog from '../../components/FormDialog/FormDialog';
import { AppState } from '../../store/rootReducer';
import { getLanguagesList } from '../../store/languages/selectors';
import { requestGetList } from '../../store/languages/actions';
import { getMissionsList } from '../../store/missions/selectors';
import {
    requestGetMissionsList,
    requestSaveMission,
    requestSaveStage,
    requestUpdateRewards,
} from '../../store/missions/actions';
import { Stage, Mission, StageExtendend } from '../../store/missions/types';
import { getStageData, getMissionData } from './actions';
import StageZero from '../../components/StageZero/StageZero';
import strings from '../../resources/strings';
import { Exercise } from '../../store/exercises/types';
import { getExercisesList } from '../../store/exercises/selectors';
import { requestDeleteExercise, requestGetListExercises, requestSaveExercise } from '../../store/exercises/actions';
import { requestGetListRewards } from '../../store/rewards/actions';
import { getRewardsList } from '../../store/rewards/selectors';
import RewardTypes from '../../resources/enums/RewardTypes';
import { AdditionalComponent, FormDialogProps } from '../../components/FormDialog/types';
import { validateLanguages } from '../../utils/Validator';
import TasksContainer from '../../components/TasksContainer/TasksContainer';
import { getTaskTypesList } from '../../store/taskTypes/selectors';
import { requestGetTaskTypesList } from '../../store/taskTypes/actions';
import { requestDeleteTask, requestGetListTasks, requestSaveTasks } from '../../store/tasks/actions';
import { Task } from '../../store/tasks/types';
import { getTasksList } from '../../store/tasks/selectors';
import { getExercisesRewards } from '../../utils/RewardsHeler';
import TaskTypes from '../../resources/enums/TaskTypes';
import { getDefaultLang } from '../../utils/LanguageHelper';
import DeleteCircleButton from '../../components/Buttons/DeleteCircleButton';
import { status } from '../../utils/StatusCalculator';
import SidebarSecondStatuses from '../../resources/enums/SidebarSecondStatuses';
import StageExitSurvey from '../../components/StageExitSurvey/StageExitSurvey';
import { isEmpty } from 'lodash';

const MissionsPage: React.FC<MissionsProps> = (props) => {
    const [listMission, setListMission] = useState<Mission[]>([]);
    const [currentMission, setCurrentMission] = useState<Mission>();
    const [currentStage, setCurrentStage] = useState<Stage | null>();
    const [currentExercise, setCurrentExercise] = useState<Exercise>();
    const [deleteEnabled, setDeleteEnabled] = useState<boolean>(false);
    const [stageZero, setStageZero] = useState<Stage>();
    const [languageValue] = React.useState(getDefaultLang(props.languages));
    const [stageExitSurvey, setStageExitSurvey] = useState<Stage>();
    const [listStage, setListStage] = useState<StageExtendend[]>([]);

    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(requestGetList());
        dispatch(requestGetMissionsList());
        dispatch(requestGetListRewards());
        dispatch(requestGetTaskTypesList());
    }, []);

    useEffect(() => {
        const sortedMissions = [...props.missions].sort((a, b) => {
            const idA = a.id.toLowerCase();
            const idB = b.id.toLowerCase();
            if (idA < idB) {
                return -1;
            } else if (idA > idB) {
                return 1;
            } else {
                return 0;
            }
        });
        setListMission(sortedMissions);
        if (!currentMission) setCurrentMission(props.missions[0]);
        if (!stageZero) setStageZero(currentMission?.stages.find((x) => x.order === 0));
        if (!stageExitSurvey) setStageExitSurvey(currentMission?.stages.find((x) => x.stageExitSurvey));
        if (currentMission) setCurrentMission(props.missions.find((x) => x.id === currentMission?.id));
    }, [props.missions]);
    useEffect(() => {
        setStageZero(currentMission?.stages.find((x) => x.order === 0));
        if (currentMission?.isSurveyDifferent) {
            setStageExitSurvey(currentMission?.stages.find((x) => x.stageExitSurvey));
        }

        setCurrentStage(currentMission?.stages.find((x) => x.id === currentStage?.id));
        setDeleteEnabled(
            status(currentMission?.publishTo ?? null, currentMission?.publishFrom ?? null) !==
                SidebarSecondStatuses.active,
        );
    }, [currentMission]);

    useEffect(() => {
        dispatch(requestGetMissionsList());
    }, [currentMission?.isSurveyDifferent]);

    useEffect(() => {
        setListStage(
            props.missions
                .find((mission) => mission.id === currentMission?.id)
                ?.stages.filter((x) => {
                    if (!currentMission?.isSurveyDifferent) {
                        return !x.stageExitSurvey;
                    }
                    return true;
                })
                .map((item) => {
                    return {
                        ...item,
                        edit: item.stageExitSurvey || item.order === 0 ? false : stageZero?.id !== item?.id,
                        order: item.stageExitSurvey ? Number.MAX_VALUE : item.order,
                    };
                })
                .sort((a, b) => a.order - b.order) ?? [],
        );
    }, [props.missions, currentMission]);

    useEffect(() => {
        if ((stageZero?.id === currentStage?.id || stageExitSurvey?.id === currentStage?.id) && currentMission)
            dispatch(
                requestGetListTasks(
                    getStageExercises(currentStage!)?.flatMap((exercise) => {
                        return exercise.tasks ? exercise.tasks : [];
                    }),
                ),
            );
    }, [props.exercises, currentStage]);

    useEffect(() => {
        if (currentExercise?.tasks && currentExercise.tasks.length > 0)
            dispatch(requestGetListTasks(currentExercise.tasks));
    }, [currentExercise]);

    const exercisesRefresh = !currentStage?.exercises?.every((x) => {
        return props.exercises
            .map((y) => {
                return y.id;
            })
            .includes(x);
    });

    const getMaxOrder = (mission?: Mission) => {
        return mission?.stages.reduce((max, obj) => (obj.order > max ? obj.order : max), mission.stages[0].order);
    };

    const getPrevMaxOrder = (mission?: Mission) => {
        let maxOrder = 0;
        let prevMaxOrder = 0;
        if (mission == null) return;
        for (const stage of mission.stages) {
            if (stage.order > maxOrder) {
                prevMaxOrder = maxOrder;
                maxOrder = stage.order;
            } else if (stage.order > prevMaxOrder && stage.order !== maxOrder) {
                prevMaxOrder = stage.order;
            }
        }
        return prevMaxOrder;
    };

    useEffect(() => {
        if (currentStage?.exercises && exercisesRefresh) dispatch(requestGetListExercises(currentStage.exercises));
    }, [currentStage]);

    editMissionsDialogParams.handleSubmit = missionsDialogParams.handleSubmit = (
        data: object,
        setOpen: React.Dispatch<React.SetStateAction<boolean>>,
        setError?: React.Dispatch<React.SetStateAction<boolean>>,
    ) => {
        const result = getMissionData(data);
        if (
            !validateLanguages([result.mission, ...result.skills], props.languages.length) ||
            isEmpty(result.mission.description) ||
            isEmpty(result.mission.exercisesTitle) ||
            isEmpty(result.mission.stagesTitle) ||
            isEmpty(result.mission.name)
        ) {
            if (setError) setError(true);
            return;
        } else {
            const isSomeExitSurvey = currentMission?.stages.some((x) => x.stageExitSurvey);
            dispatch(requestSaveMission(result.mission, result.skills, result.isNewMission, isSomeExitSurvey ?? false));
            setOpen(false);
        }
    };

    editStagesDialogParams.handleSubmit = stagesDialogParams.handleSubmit = (
        data: object,
        setOpen: React.Dispatch<React.SetStateAction<boolean>>,
        setError?: React.Dispatch<React.SetStateAction<boolean>>,
    ) => {
        let stage = getStageData(
            data,
            currentMission?.isSurveyDifferent
                ? (getPrevMaxOrder(currentMission) ?? 0) + 1
                : (getMaxOrder(currentMission) ?? 0) + 1,
        );
        if (!validateLanguages([stage], props.languages.length) || isEmpty(stage.name) || isEmpty(stage.description)) {
            if (setError) setError(true);
            return;
        } else {
            if (currentStage?.id === stage.id) {
                stage = { ...stage, exercises: currentStage?.exercises, order: currentStage?.order };
            }
            if (currentMission?.id) {
                dispatch(requestSaveStage(stage, currentMission?.id));
                setOpen(false);
            }
        }
    };

    editExercisesDialogParams.handleSubmit = exercisesDialogParams.handleSubmit = (
        data: object,
        setOpen: React.Dispatch<React.SetStateAction<boolean>>,
        setError?: React.Dispatch<React.SetStateAction<boolean>>,
    ) => {
        if (!validateLanguages([data], props.languages.length) || isEmpty((data as Exercise).name)) {
            if (setError) setError(true);
            return;
        } else if (currentMission && currentStage) {
            const modifiedCurrendExercise = data as Exercise;
            const rewards = getExercisesRewards(modifiedCurrendExercise, currentMission, props.exercises);
            dispatch(requestSaveExercise(currentMission.id, currentStage, modifiedCurrendExercise));
            dispatch(requestUpdateRewards(rewards, currentMission.id));
            setCurrentExercise(modifiedCurrendExercise);
            setOpen(false);
        }
    };

    const getExercisesList = () => {
        const exercises = [] as Exercise[];
        props.exercises.forEach((exercise) => {
            if (currentStage?.exercises?.includes(exercise.id)) exercises.push(exercise);
        });
        return exercises.map((x) => {
            return {
                ...x,
                missionSkills: currentMission?.skills,
                badges: props.rewards.filter((x) => x.type === RewardTypes.Badge),
            };
        });
    };

    const getAddExerciseParams = () => {
        return {
            ...exercisesDialogParams,
            component: {
                ...exercisesDialogParams.component,
                data: [
                    {
                        missionSkills: currentMission?.skills,
                        badges: props.rewards.filter((x) => x.type === RewardTypes.Badge),
                    },
                ],
            } as AdditionalComponent,
        } as FormDialogProps;
    };

    const handleSubmitTasks = (tasks: Task[]) => {
        if (!(currentMission && currentStage && currentExercise)) return;
        const modifiedCurrendExercise = {
            ...currentExercise,
            tasks: tasks.map((item) => {
                return item.id;
            }),
        };
        setCurrentExercise(modifiedCurrendExercise);
        dispatch(requestSaveTasks(tasks));
        dispatch(requestSaveExercise(currentMission.id, currentStage, modifiedCurrendExercise));
    };

    const getStageExercises = (stage: Stage | undefined) => {
        if (!stage) return [];
        return props.exercises.filter((x) => stage?.exercises?.includes(x.id));
    };

    const deleteTask = (id: string) => {
        if (!(currentMission && currentStage && currentExercise)) return;
        const modifiedCurrendExercise = {
            ...currentExercise,
            tasks: currentExercise?.tasks?.filter((x) => x !== id),
        } as Exercise;
        setCurrentExercise(modifiedCurrendExercise);
        dispatch(requestDeleteTask(id));
        dispatch(requestSaveExercise(currentMission.id, currentStage, modifiedCurrendExercise));
    };

    const deleteExercise = (id: string) => {
        if (!(currentMission && currentStage)) return;
        const modifiedCurrendStage = {
            ...currentStage,
            exercises: currentStage?.exercises?.filter((x) => x !== id),
        } as Stage;
        const tasks = props.exercises.find((x) => x.id === id)?.tasks ?? [];
        setCurrentStage(modifiedCurrendStage);
        dispatch(requestSaveStage(modifiedCurrendStage, currentMission.id));
        dispatch(requestDeleteExercise(id, tasks));
        if (currentExercise?.id === id) setCurrentExercise(undefined);
    };

    return (
        <div className="content">
            <Sidebar></Sidebar>
            <SidebarSecond
                data={listMission}
                actualLanguage={languageValue}
                actualItemId={currentMission?.id}
                title={strings.missions.missionsTitle}
                setActualItemId={(id: string) => {
                    if (!listMission) return;
                    setCurrentMission(listMission.find((el) => el.id === id));
                    setCurrentStage(null);
                    setCurrentExercise(undefined);
                }}
                addButton={{ component: FormDialog, params: missionsDialogParams, languages: props.languages }}
                editButton={{ component: FormDialog, params: editMissionsDialogParams, languages: props.languages }}
            ></SidebarSecond>
            <SidebarSecond
                data={listStage}
                actualLanguage={languageValue}
                actualItemId={currentStage?.id}
                title={strings.missions.stagesTitle}
                isAddNew={true}
                setActualItemId={(id: string) => {
                    if (!currentMission?.stages) return;
                    setCurrentStage(currentMission?.stages.find((el) => el.id === id));
                    setCurrentExercise(undefined);
                }}
                hideStatus={true}
                addButton={{ component: FormDialog, params: stagesDialogParams, languages: props.languages }}
                editButton={{ component: FormDialog, params: editStagesDialogParams, languages: props.languages }}
            ></SidebarSecond>
            {stageZero?.id === currentStage?.id && currentMission ? (
                <>
                    <StageZero
                        {...stageZero}
                        languages={props.languages}
                        skills={currentMission.skills}
                        missionId={currentMission.id}
                        exercisesData={getStageExercises(stageZero)}
                        tasksData={props.tasks}
                        taskType={props.taskTypes.find((x) => x.type === TaskTypes.QuestionAndAnswers)?.id}
                        mission={currentMission}
                        reports={stageZero?.reports}
                        valueGroups={stageZero?.valueGroups}
                        deleteEnabled={deleteEnabled}
                        maxPoints={stageZero?.maxPoints}
                    ></StageZero>
                </>
            ) : stageExitSurvey?.id === currentStage?.id &&
              currentMission &&
              !!stageExitSurvey &&
              currentMission.isSurveyDifferent ? (
                <>
                    <StageExitSurvey
                        exitSurveyStage={stageExitSurvey}
                        skills={currentMission.skills}
                        tasksData={props.tasks}
                        taskType={props.taskTypes.find((x) => x.type === TaskTypes.QuestionAndAnswers)?.id}
                        languages={props.languages}
                        exercisesData={getStageExercises(stageExitSurvey)}
                        missionId={currentMission.id}
                    />
                </>
            ) : currentStage && !currentStage.stageExitSurvey ? (
                <>
                    <SidebarSecond
                        data={getExercisesList()}
                        actualLanguage={languageValue}
                        actualItemId={currentExercise?.id}
                        title={strings.missions.exercisesTitle}
                        isAddNew={true}
                        setActualItemId={(id: string) => {
                            setCurrentExercise(props.exercises.find((el) => el.id === id));
                        }}
                        hideStatus={true}
                        addButton={{
                            component: FormDialog,
                            params: getAddExerciseParams(),
                            languages: props.languages,
                        }}
                        editButton={{
                            component: FormDialog,
                            params: editExercisesDialogParams,
                            languages: props.languages,
                        }}
                        deleteButton={
                            deleteEnabled
                                ? {
                                      component: DeleteCircleButton,
                                      params: {
                                          action: (id?: string) => {
                                              if (id) deleteExercise(id);
                                          },
                                      },
                                  }
                                : undefined
                        }
                    ></SidebarSecond>
                    {currentExercise ? (
                        <TasksContainer
                            languages={props.languages}
                            taskTypes={props.taskTypes}
                            skills={currentMission?.skills.filter((item) => currentExercise.skills?.includes(item.id))}
                            tasks={
                                currentExercise.tasks && currentExercise.tasks.length > 0
                                    ? props.tasks.filter((item) => currentExercise.tasks?.includes(item.id))
                                    : []
                            }
                            handleSubmit={handleSubmitTasks}
                            deleteEnabled={deleteEnabled}
                            deleteTask={deleteTask}
                        ></TasksContainer>
                    ) : (
                        ''
                    )}
                </>
            ) : (
                ''
            )}
        </div>
    );
};

function mapStateToProps(state: AppState) {
    return {
        userId: getUserId(state),
        languages: getLanguagesList(state),
        missions: getMissionsList(state),
        exercises: getExercisesList(state),
        rewards: getRewardsList(state),
        taskTypes: getTaskTypesList(state),
        tasks: getTasksList(state),
    };
}

export default connect(mapStateToProps)(MissionsPage);
